const questionsHTML = [
    {
        questionText: 'Как расшифровывается "HTML"?',
        answerOptions: [
            { answerText: 'язык гиперзвуковой разметки', isCorrect: false },
            { answerText: 'язык гипертекстовой разметки', isCorrect: true },
            { answerText: 'язык гигачад разметки', isCorrect: false },
            { answerText: 'язык гигантской разметки', isCorrect: false },
        ],
    },
    {
        questionText: 'Какие типы позиционирования существуют?',
        answerOptions: [
            { answerText: 'относительное, абсолютное', isCorrect: false },
            { answerText: 'относительное, абсолютное, парадоксальное, статичное', isCorrect: false },
            { answerText: 'абсолютное, статичное, относительное, фиксированное', isCorrect: true },
            { answerText: 'абсолютное, статичное, фиксированное', isCorrect: false },
        ],
    },
    {
        questionText: 'Какого значения у justify-content не существует:',
        answerOptions: [
            { answerText: 'center', isCorrect: false },
            { answerText: 'flex-end', isCorrect: false },
            { answerText: 'flex', isCorrect: true },
            { answerText: 'space-evenly', isCorrect: false },
        ],
    },
    {
        questionText: 'Что определяет свойство flex-direction?',
        answerOptions: [
            { answerText: 'направление текста во флекс-контейнере', isCorrect: false },
            { answerText: 'расположение флекс элементов во флекс контейнере', isCorrect: true },
            { answerText: 'направление цвета бэкграунда', isCorrect: false },
            { answerText: 'расположение внутренних отступов внутри флекс элементов', isCorrect: false },
        ],
    },
    {
        questionText: 'Что позволяет контролировать свойство z-index?',
        answerOptions: [
            { answerText: 'глубину расположения элементов на странице', isCorrect: true },
            { answerText: 'степень прозрачности заднего фона', isCorrect: false },
            { answerText: 'толщину бордера', isCorrect: false },
            { answerText: 'горизонтальное расположение элементов', isCorrect: false },
        ],
    },
    {
        questionText: 'Медиазапросы всегда начинаются с правила ...?',
        answerOptions: [
            { answerText: '@smm', isCorrect: false },
            { answerText: '@VitalikButerin', isCorrect: false },
            { answerText: '@media', isCorrect: true },
            { answerText: '@mmm', isCorrect: false },
        ],
    },
    {
        questionText: 'При создании респонсивных изображений надо учитывать:',
        answerOptions: [
            { answerText: 'влажность воздуха, давление, уф-индекс', isCorrect: false },
            { answerText: 'степень обжарки, способ обработки, плотность темперовки', isCorrect: false },
            { answerText: 'размер девайса, размер изображения, разрешение экрана', isCorrect: true },
            { answerText: 'мнение коллег, лучшего друга, родителей', isCorrect: false },
        ],
    },
    {
        questionText: 'Атрибут method в теге <form> принимает значение:',
        answerOptions: [
            { answerText: 'let', isCorrect: false },
            { answerText: 'get', isCorrect: true },
            { answerText: 'cut', isCorrect: false },
            { answerText: 'put', isCorrect: false },
        ],
    },
    {
        questionText: 'Что делает тег <title>?',
        answerOptions: [
            { answerText: 'влияет на плавность анимации', isCorrect: false },
            { answerText: 'заменяет тег <p>', isCorrect: false },
            { answerText: 'задает надпись на вкладке браузера', isCorrect: true },
            { answerText: 'создает новый блок в потоке страницы', isCorrect: false },
        ],
    },
    {
        questionText: 'Какой из перечисленных элементов является блочным?',
        answerOptions: [
            { answerText: '<em>', isCorrect: false },
            { answerText: '<a>', isCorrect: false },
            { answerText: '<nav>', isCorrect: true },
            { answerText: '<b>', isCorrect: false },
        ],
    },
];

export default questionsHTML;
